module.exports = __webpack_public_path__ + "img/Orbiting-Inspect-Small.9a56cd04.png";